<template>
  <div>
   <page-control :model="page" class="content-container" />
  </div>
</template>
<script>
import router from '../../router/router.index'

import PageControl from '../app/PageControl.vue'

export default {
  name: 'DynamicPagePrototype',
  data: () => ({
    page: {}
  }),
  components: {
    PageControl
  },
  async created() {
    window.addEventListener('message', this.handlerMessage)
    window.onstorage = this.handleStorage
  },
  mounted() {
    window.addEventListener('message', this.handlerMessage)
    window.onstorage = this.handleStorage

    const pageData = localStorage.getItem('corporate.site.preview')
    if (pageData) {
      try {
        this.page = JSON.parse(pageData)
      } catch (e) {
        this.$uiService.error('Помилка відображення')
      }
    } else {
      this.$router.push({ name: 'error404' })
    }
  },
  methods: {
    handlerMessage(data) {
      if (data.data.message === 'update-page') {
        localStorage.setItem('corporate.site.preview', JSON.stringify(data.data.parameters))
        const pageData = data.data.parameters
        if (pageData) {
          this.page = data.data.parameters
        } else {
          this.$uiService.error('Помилка відображення')
        }
      }
    },
    handleStorage(data) {
      const pageData = JSON.parse(localStorage.getItem('corporate.site.preview'))
      if (pageData) {
        this.page = pageData
      } else {
        this.$uiService.error('Помилка відображення')
      }
    }
  }
}
</script>
<style lang="scss" >
@import '~vuetify/src/styles/settings/_variables';
@import '@/scss/main.scss';
.content-container {
  @include page-content-style;
}

@media #{map-get($display-breakpoints, 'md-and-down')} {
  .content-container > .content-wrapper.standart .content {
    padding-left: 0.8rem;
    padding-right: 0.8rem;
  }
}
</style>
